// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"b6beccb7","331":"39ea03e7","453":"d988e699","657":"32a8a8f2","879":"6f4ef94e"}[chunkId] + ".chunk.js";
};